export const actualScrollGa = (path, title) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
    'event': 'Pageview',
    'pagePath': path,
    'pageTitle': title
    });
}